import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ly-row mt-2 ly-even-2" }

import { ref, computed, Ref, inject } from 'vue'
import { Redirect } from '@/types/redirect'


export default /*@__PURE__*/_defineComponent({
  __name: 'NewForgotPasswordForm',
  props: ['isSubmitting'],
  emits: ['formSubmitted'],
  setup(__props, { emit: __emit }) {

const redirect = inject('redirect') as Redirect
const props = __props
const email: Ref<string> = ref('')
const emit = __emit
const disableForm = computed(() => !email.value)

const formSubmitted = () => {
  window.localStorage.setItem('email', email.value)
  const provider = window.localStorage.getItem('provider') || 'LMS'
  email.value = email.value.trim()
  emit('formSubmitted', {
    email: email.value,
    provider
  })
}

const goBack = () => {
  redirect('LoginView')
}


return (_ctx: any,_cache: any) => {
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_lp_button = _resolveComponent("lp-button")!

  return (_openBlock(), _createElementBlock("form", {
    class: "forgot-password-form",
    onSubmit: _withModifiers(formSubmitted, ["prevent"])
  }, [
    _cache[2] || (_cache[2] = _createElementVNode("h1", { class: "mb-2" }, "Reset Your Password", -1)),
    _cache[3] || (_cache[3] = _createElementVNode("p", { class: "mb-2 text-size-normal" }, "Enter the email address associated with your account, and we will send you a link to reset your password.", -1)),
    _createVNode(_component_lp_input, {
      modelValue: email.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
      "label-top": "Email Address",
      placeholder: "name@example.com",
      compact: ""
    }, null, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        onClick: goBack,
        type: "button"
      }, "Return to Sign In"),
      _createVNode(_component_lp_button, {
        disabled: disableForm.value || props.isSubmitting,
        loading: props.isSubmitting,
        type: "primary",
        class: "btn-loading-active"
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode("Request Reset Link", -1)
        ]))]),
        _: 1
      }, 8, ["disabled", "loading"])
    ])
  ], 32))
}
}

})